/**
 * @generated SignedSource<<f09444229ad0c051a7b72c1cb9d3dc8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemInternalContext_nftItem$data = {
  readonly balanceForUser?: {
    readonly balance: number | null;
    readonly ownerAddress: {
      readonly address: string | null;
    } | null;
  } | null;
  readonly creatorAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentType": "ItemInternalContext_nftItem";
};
export type ItemInternalContext_nftItem$key = {
  readonly " $data"?: ItemInternalContext_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemInternalContext_nftItem">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "address",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemInternalContext_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "NftItemBalance",
          "kind": "LinkedField",
          "name": "balanceForUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EthereumAddressType",
              "kind": "LinkedField",
              "name": "ownerAddress",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};
})();

(node as any).hash = "232e88bbe344a86ff3cab9503383554e";

export default node;
